import BaseFilterController from '../base/BaseFilterController.js';

/**
 * PublicationsFilter
 *
 * Handles two modes of the posts-grid-section block:
 *   - "all"               — filters: category, tag, author  (20 posts/page)
 *   - "selected_category" — filters: tag, author only       (8 posts/page, fixed category via data-category-id)
 *
 * If the category select is absent from the DOM (selected_category mode),
 * BaseFilterController silently skips it — no extra handling needed.
 */
export default class PublicationsFilter extends BaseFilterController {
    constructor(section) {
        super(section, {
            category: {
                selector: '[data-category-dropdown]',
                type: 'checkboxGroup',
            },
            tag: {
                selector: '[data-tag-dropdown]',
                type: 'checkboxGroup',
            },
            author: {
                selector: '[data-author-dropdown]',
                type: 'checkboxGroup',
            },
        });

        console.log('PublicationsFilter initialized');
    }

    /** Override fetchResults to pass categoryId for fixed-category mode */
    async fetchResults(append = false) {
        this.section.classList.add('loading');

        try {
            const body = new URLSearchParams({
                postType:     this.config.postType,
                postsPerPage: this.config.postsPerPage,
                paged:        this.state.currentPage,
                order:        this.config.order,
                filters:      JSON.stringify(this.filters),
                categoryId:   this.section.dataset.categoryId || 0,
            });

            const res = await fetch(this.config.endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body,
            });

            const data = await res.json();
            this.renderResults(data, append);
        } catch (err) {
            console.error('PublicationsFilter fetch error:', err);
        } finally {
            this.section.classList.remove('loading');
        }
    }
}
